import { gql } from '@apollo/client';
import { GetStaticPaths, GetStaticProps } from 'next';
import CoursePage from '../../../components/elements/CoursePage';
import { COURSE_PAGE } from '../../../queries/courses';
import { Courses } from '../../../types/schema';
import { initializeApollo } from '../../../utils/apollo';
import { flatten } from '../../../utils/object';
import rollbar from '../../../utils/rollbar';

type ProjectsProps = {
  coursePage: Courses;
  popularCourses: Courses[];
};

const ProjectPage: React.FC<ProjectsProps> = ({ coursePage, popularCourses }) => {
  return <CoursePage course={coursePage} popularCourses={popularCourses} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const apolloClient = initializeApollo();
  const { data } = await apolloClient.query({
    query: gql`
      query GetCoursesSlug {
        courses(locale: "pt") {
          data {
            id
            attributes {
              slug
            }
          }
        }
      }
    `,
  });

  const newData = flatten(data);

  const paths = ((newData.courses || []) as Courses[]).map((course: Courses) => {
    return {
      params: { slug: course.slug },
    };
  });
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (ctx) => {
  const { slug } = ctx.params!;
  const apolloClient = initializeApollo();

  try {
    const { data } = await apolloClient.query({
      query: COURSE_PAGE,
      variables: {
        slug,
      },
    });

    const newData = flatten(data);

    return {
      props: {
        coursePage: ((newData.courses || []) as Courses[])[0],
        popularCourses: newData.popularCourses,
      },
      revalidate: 60,
    };
  } catch (error) {
    rollbar.error('Error fetching course page', { error, slug });
    return {
      notFound: true,
    };
  }
};

export default ProjectPage;
